module.exports = __webpack_public_path__ + "img/img01@2x.632507ae.png";